module.exports = __webpack_public_path__ + "img/img-scene-4.83f94535.jpg";